import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
import MissionVision from "../aboutus/MissionVision";
import { Fade } from "react-awesome-reveal";
import { ICraftsmanshipSlider, IMissionVision } from "../../exports/interfaces";

const Info = (props: {
  missionVisionData: IMissionVision[];
  craftsmanshipSlider: ICraftsmanshipSlider[];
}) => {
  const mobile = useMobile();
  const tab = useTab();
  const images = props.craftsmanshipSlider?.map((data) => {
    return {
      image: data?.image[0]?.media?.name,
      title: data?.title,
    };
  });

  return (
    <>
      <div>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-48c84d06 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="48c84d06"
          data-element_type="section"
          data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        >
          <div
            className="elementor-container elementor-column-gap-default"
            style={{ maxWidth: "unset" }}
          >
            <div className="elementor-row">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-753ac9ef"
                data-id="753ac9ef"
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap custom-elementor-title">
                    <Fade
                      cascade
                      damping={0.2}
                      direction="up"
                      triggerOnce={true}
                    >
                      <div
                        className="elementor-element elementor-element-764d6a6 elementor-invisible elementor-widget elementor-widget-heading"
                        data-id="764d6a6"
                        data-element_type="widget"
                        data-settings='{"_animation":"fadeInUp","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Unique Craftsmanship
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-168f4c49 elementor-invisible elementor-widget elementor-widget-heading"
                        data-id="168f4c49"
                        data-element_type="widget"
                        data-settings='{"_animation":"fadeInUp","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h5 className="elementor-heading-title elementor-size-default">
                            in SINAMANGAL, KATHMANDU
                          </h5>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section
          className="elementor-section elementor-top-section elementor-element elementor-element-f60fd59 elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-invisible"
          data-id="f60fd59"
          data-element_type="section"
          data-settings='{"animation":"fadeInUp","animation_delay":400,"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        >
          <div className="elementor-container elementor-column-gap-wider">
            <div
              className="elementor-row custom-row-element"
              style={{ display: "flex", gap: "30px" }}
            >
              <div
                className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-55dae2d custom-elementor-top-column"
                data-id="55dae2d"
                style={{ flex: 1 }}
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap">
                    <div
                      className="elementor-element elementor-element-3bd79c7 elementor-widget elementor-widget-text-editor"
                      data-id="3bd79c7"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-text-editor elementor-clearfix">
                          <p>
                            Uniquely Elegant, Exclusive Comfort, Timeless Style.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-37f8569 elementor-widget elementor-widget-button"
                      data-id="37f8569"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="button.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-button-wrapper">
                          <a
                            href="/our-rooms"
                            className="elementor-button-link elementor-button elementor-size-sm elementor-animation-shrink"
                            role="button"
                            // style={{ padding: "10px 15px" }}
                          >
                            <span className="elementor-button-content-wrapper">
                              <span className="elementor-button-text">
                                Explorer More
                              </span>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6033ce2 custom-elementor-top-column"
                data-id="6033ce2"
                style={{ flex: 2 }}
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap">
                    <div
                      className="elementor-element elementor-element-a0b0831 elementor-widget elementor-widget-text-editor"
                      data-id="a0b0831"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-text-editor elementor-clearfix custom-elementor-clearfix">
                          <p>
                            <ul>
                              <li>
                                At Hotel Bayberry, each wooden design is crafted
                                from scratch, blending the artistry of
                                traditional woodcraft with modern elegance. The
                                seamless fusion of natural textures and
                                contemporary style creates a warm, inviting
                                atmosphere, offering guests an experience of
                                refined luxury and craftsmanship.
                              </li>
                              <li>
                                Experience uniquely elegant luxury at Hotel
                                Bayberry, where exclusive comfort meets timeless
                                style. Our beautifully designed rooms offer
                                refined ambiance, blending modern amenities with
                                classic charm. Relax, indulge, and enjoy a stay
                                that redefines elegance, ensuring a memorable
                                and captivating experience.
                              </li>
                              <li>
                                Our restaurant offers a perfect fusion of
                                flavors, thoughtfully crafted to delight your
                                palate. With a unique blend of dishes and
                                carefully selected beverages, each meal promises
                                a savory experience, combining taste and
                                presentation to create unforgettable dining
                                moments.
                              </li>
                            </ul>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <Fade direction="up" triggerOnce={true}>
          <MissionVision missionVisionData={props.missionVisionData} />
        </Fade>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-69e827d elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default elementor-invisible"
          data-id="69e827d"
          data-element_type="section"
          data-settings='{"stretch_section":"section-stretched","animation":"fadeInUp","animation_delay":600,"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div className="elementor-row">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4008f9e"
                data-id="4008f9e"
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap">
                    <div
                      className="elementor-element elementor-element-8d93419 elementor-widget elementor-widget-hoteller-gallery-horizontal"
                      data-id="8d93419"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="hoteller-gallery-horizontal.default"
                    >
                      <div className="elementor-widget-container">
                        <div
                          className="tg_horizontal_gallery_wrapper"
                          // data-autoplay="0"
                          // data-loop="0"
                          // data-navigation="1"
                          // data-pagination="0"
                          // data-parallax="0"
                          // data-fullscreen="0"
                        >
                          <Fade direction="up" triggerOnce={true}>
                            <div
                              className="tg_horizontal_gallery_cell custom-info-slideshow__slide-image"
                              style={{ height: "80dvh" }}
                            >
                              <Swiper
                                key={images?.length || 0}
                                modules={[Navigation, Autoplay]}
                                slidesPerView={mobile || tab ? 2 : 3}
                                navigation
                                spaceBetween={10}
                                grabCursor={true}
                                loop={true}
                                observer={true}
                                observeParents={true}
                                autoplay={{
                                  delay: 3000,
                                  disableOnInteraction: false,
                                  pauseOnMouseEnter: false,
                                }}
                                style={{
                                  height: "100%",
                                }}
                              >
                                {images?.map((image, index) => {
                                  return (
                                    <SwiperSlide key={index}>
                                      <div
                                        className="slideshow__slide-image background-absolute custom-info-slideshow__slide-image"
                                        style={{
                                          height: "80dvh",
                                          backgroundImage: image?.image
                                            ? `url(${process.env.REACT_APP_cmsUrl}/uploads/${image?.image})`
                                            : "url(https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                        }}
                                      >
                                        <div
                                          className="elementor-widget-wrap"
                                          style={{
                                            height: "100%",
                                            alignContent: "flex-end",
                                            alignItems: "flex-end",
                                          }}
                                        >
                                          <div
                                            className="elementor-element elementor-element-62c2ce66 elementor-widget elementor-widget-heading"
                                            data-id="62c2ce66"
                                            data-element_type="widget"
                                            data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                            data-widget_type="heading.default"
                                            style={{
                                              marginBottom: "20%",
                                            }}
                                          >
                                            <div className="elementor-widget-container custom-elementor-widget-container">
                                              <h2 className="elementor-heading-title elementor-size-default">
                                                {image?.title}
                                              </h2>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="custom-gradient"></div>
                                      </div>
                                    </SwiperSlide>
                                  );
                                })}
                              </Swiper>
                            </div>
                          </Fade>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <style>
          {`
                    .swiper-button-next,
                    .swiper-button-prev {
                        height: 26px;
                    }
                    .swiper-button-next::after,
                    .swiper-button-prev::after {
                        color: white;
                        font-size: 24px;
                    }
                    .swiper-pagination-bullet {
                        background-color: #ffffff;
                    }
                    .swiper-pagination {
                        bottom: 11px !important;
                    }
                    @media (max-width: 810px) {
                        .swiper-pagination {
                            bottom: 17px !important;
                        }
                    }
                `}
        </style>
      </div>
    </>
  );
};

export default Info;
